import { render } from "./NewWordList.vue?vue&type=template&id=fdd3ad2a&scoped=true"
import script from "./NewWordList.vue?vue&type=script&lang=js"
export * from "./NewWordList.vue?vue&type=script&lang=js"

import "./NewWordList.vue?vue&type=style&index=0&id=fdd3ad2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd3ad2a"]])

export default __exports__